import React from 'react'
import Withdrawal from '@shared/svg/withdrawal.svg'
import Rub from '@shared/svg/rub.svg'
import Time from '@shared/svg/time.svg'
import Portfel from '@shared/svg/portfel.svg'

export const productCardPoints = [
	{
		Icon: Rub,
		title: 'От 200 тысяч до 15 млн рублей',
	},
	{
		Icon: Portfel,
		title: 'Срок — до 5 лет',
	},
	{
		Icon: Time,
		title: 'Доступно продление срока',
	},
	{
		Icon: Withdrawal,
		title: 'Выдаем до 70% от стоимости объекта',
	},
]

export const productCardPaymentTypes = [
	{
		name: 'Процентный',
		content: 'Сначала выплачиваются только проценты, в конце срока — всё тело кредита.',
		period: 'до 1 года',
	},
	{
		name: 'Заёмная линия',
		content:
			'Человек по заявлению получает деньги в рамках лимита и возвращает процентными платежами до неснижаемого остатка.',
		period: 'до 1 года',
	},
	{
		name: 'Аннуитетный',
		content: 'Равный ежемесячный платёж, который включает проценты и тело кредита.',
		period: 'до 5 лет',
	},
]

export const productCardBorrowerRequirements = [
	'ИП, юридическое или физическое лицо',
	'От 18 до 65 лет',
	'Рассмотрим заявку с любой кредитной историей',
]

export const productCardImportant = (
	<>
		Недвижимость остаётся в вашей собственности. <br />
		<br />
		Сделка оформляется через регистрацию обременения в Росреестре. Оно снимается в течение 3-5 дней
		после возврата долга.
	</>
)
